import domain, { initialState } from './domain'
import favourites from './favourites'
import directFavourites from './direct-favourites'
import savedSearches from './saved-search'

export { domain, initialState }
export const entities = {
  favourites,
  directFavourites,
  savedSearches,
}
